import * as Yup from "yup"
import { AcademicLevel, Accompagnateurs, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Section, SlotId, Specialites } from "services/validation"

const schema = Yup.object().shape({
  ...Accompagnateurs,
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  formations: Yup.array().min(1, 'Vous devez choisir au minimum un programme'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...Section,
  }),
  ...SlotId,
  ...Specialites
})

export default schema
